import React from "react";
import OrderTable from "../Table";

const OrderConfirmed = () => {
  return <OrderTable type="Order Confirmed" />;
};

export default OrderConfirmed;
